// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"b20b73d8","153":"d255ef23","317":"97d70486","386":"d3507527","552":"207df155","579":"3b6ff04f","680":"5ce06f08","877":"4331f08b"}[chunkId] + ".chunk.js";
};